export default __webpack_public_path__ + "static/media/0xaa9654becca45b5bdfa5ac646c939c62b527d394.8b959d0f.webp";